import { render, staticRenderFns } from "./AppNotifications.vue?vue&type=template&id=36890066&scoped=true"
import script from "./AppNotifications.vue?vue&type=script&lang=js"
export * from "./AppNotifications.vue?vue&type=script&lang=js"
import style0 from "./AppNotifications.vue?vue&type=style&index=0&id=36890066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36890066",
  null
  
)

export default component.exports